export default {
  answerThreshold: 'Answer threshold',
  dependencyCriteria: 'Dependency criteria',
  dependedQuestion: 'Depended question',
  answerRequired: 'Answer required',
  minimumOptionLengthIs_: 'Minimim Option length is 2',
  option: 'Option',
  options: 'Options',
  number: 'Number',
  welcomeTitle: 'Wellcome title',
  thankYouTitle: 'Thank you title',
  welcomePage: 'Welcome page',
  thankYouPage: 'Thank page',
  fillAtLeastOneOf_InputsRequired:
    'Fill at least one of {page} inputs required',
  Text: 'Text',
  questions: 'questions',
  noQuestionAdded: 'No question added',
  questionTypes: {
    text: 'Text',
    option: 'Option',
    dropdown: 'Dropdown',
    range: 'Range',
    ranking: 'Ranking',
    file: 'Upload file',
    statement: 'Text without answer'
  },
  textViewNames: {
    default: 'Short answer',
    textarea: 'Long answer',
    url: 'Link',
    number: 'Number',
    email: 'Email',
    mobile: 'Mobile'
  },
  optionViewNames: {
    default: 'Text',
    image: 'With image'
  },
  dropdownViewNames: {
    default: 'Default'
  },
  rangeViewNames: {
    default: 'Range',
    score: 'Score'
  },
  rankingViewNames: {
    default: 'Default'
  },
  fileViewNames: {
    default: 'Default'
  },
  statementViewNames: {
    default: 'Default'
  },
  questionSettings: 'Question settings',
  payAttentionOnQuestionDetail: 'Pay attention on question detail',
  availableStartTime: 'Available start time',
  availableExpireTime: 'Available expire time',
  defaultWelcomeTitle: 'Welcome',
  defaultThankYouTitle: 'Thank you',
  questionCategoryId: 'Question Category ID',
  cantLinkQuestionsWithThisCount:
    'With this number of questions, it is not possible to create links between questions',
  oneOrMoreQuestionsHaveNoTitle: 'One or more questions have no title',
  dependentQuestionSettings: 'Dependent question settings',
  addDependency: 'Add dependency',
  dependency: 'Dependency',
  goToQuestion: 'Go to question',
  conditions: 'Conditions',
  answerOfQuestion: 'Answer of question'
}
